import { createNode } from '@glueapp/graph-types';

export const FunctionInputsNode = createNode({
    id: 'function-inputs',
    name: 'Function Inputs',
    description: 'Manages input interface for this function',
    aiDescription: [
        'Internal function-system node — auto-created inside each function, not user-addable.',
        "Its output ports are dynamically generated from the containing function's inputPortDefinitions via computeShape.",
        "You cannot configure this node directly; edit the function definition's input ports instead.",
    ].join('\n'),
    category: 'Function System',
    color: '#2196F3',
    findableInLibrary: false, // Only auto-created, not user-addable
    hideInherentInPort: true,
    inPorts: {},
    outPorts: {},

    computeShape: ({ containingFunctionDefinition }) => {
        // Compute outPorts from the current function's input port definitions
        const outPorts =
            containingFunctionDefinition?.inputPortDefinitions?.map(def => ({
                name: def.name,
                type: def.type,
                optional: def.optional || false,
            })) || [];

        return {
            inPorts: [], // Function inputs have no input ports
            outPorts,
        };
    },

    // This execute function does not run during graph execution.
    // The graph's general execution logic does the wiring of putting
    // the functions inputs onto the output ports of this node directly.
    execute: () => {
        return {
            output: {},
        };
    },
});
